import { Skeleton } from '@mui/material'
import Chip from '@mui/material/Chip'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'

const DatosSolicitudSkeleton = () => {
  return (
    <>
      <List>
        <Divider textAlign="left" sx={{ marginTop: 2, marginBottom: 1 }}>
          <Chip label={<Skeleton variant="rounded" width={100} />} />
        </Divider>
        <ListItem
          key={1}
          disablePadding
          sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
        >
          <Skeleton variant="rectangular" width={'20%'} height={20} />
          <Skeleton variant="rectangular" width={'40%'} height={40} />
        </ListItem>
        <Divider component="li" sx={{ m: 2 }} />
        <ListItem
          key={1}
          disablePadding
          sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
        >
          <Skeleton variant="rectangular" width={'20%'} height={20} />
          <Skeleton variant="rectangular" width={'40%'} height={40} />
        </ListItem>
        <Divider textAlign="left" sx={{ marginTop: 2, marginBottom: 1 }}>
          <Chip label={<Skeleton variant="rounded" width={100} />} />
        </Divider>
        <ListItem
          key={1}
          disablePadding
          sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
        >
          <Skeleton variant="rectangular" width={'20%'} height={20} />
          <Skeleton variant="rectangular" width={'40%'} height={40} />
        </ListItem>
        <Divider component="li" sx={{ m: 2 }} />
        <ListItem
          key={1}
          disablePadding
          sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
        >
          <Skeleton variant="rectangular" width={'20%'} height={20} />
          <Skeleton variant="rectangular" width={'40%'} height={40} />
        </ListItem>
        <Divider component="li" sx={{ m: 2 }} />
        <ListItem
          key={1}
          disablePadding
          sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: 1 }}
        >
          <Skeleton variant="rectangular" width={'20%'} height={20} />
          <Skeleton variant="rectangular" width={'40%'} height={40} />
        </ListItem>
      </List>
    </>
  )
}

export default DatosSolicitudSkeleton
